import GeneralDialog from '../../../shared/general-dialog';
import { ContactSyncModel } from '../../../../types';
import AvatarChip from '../../../shared/avatar-chip';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Check from '@mui/icons-material/Check';
import DoNotDisturb from '@mui/icons-material/DoNotDisturb';
interface ContactSyncDetailsDialogProps {
  open: boolean;
  handleClose: () => void;
  selectedContactSync: ContactSyncModel;
}

export default function ContactSyncDetailsDialog({
  open,
  handleClose,
  selectedContactSync,
}: ContactSyncDetailsDialogProps) {
  return (
    <GeneralDialog
      open={open}
      handleClose={handleClose}
      title="Contact Sync Details"
      maxWidth="md"
      dialogContent={
        <>
          <Stack sx={{ pt: 2, pl: 4 }}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 4 }}>
                <Stack>
                  <Typography
                    sx={{
                      fontWeight: 600,
                    }}
                  >
                    Sync Name:
                  </Typography>
                  <Typography
                    noWrap
                    sx={{
                      maxWidth: 200,
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {selectedContactSync.name}
                  </Typography>
                </Stack>
              </Grid>
              <Grid size={{ xs: 4 }}>
                <Stack>
                  <Typography
                    sx={{
                      fontWeight: 600,
                    }}
                  >
                    Sync Type:
                  </Typography>
                  <Typography
                    noWrap
                    sx={{
                      maxWidth: 200,
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {selectedContactSync.syncType === 'directory'
                      ? 'Directory Sync'
                      : selectedContactSync.syncType === 'contact'
                      ? 'Contact Sync'
                      : 'Bi-Directional Sync'}
                  </Typography>
                </Stack>
              </Grid>
              {selectedContactSync.description ? (
                <Grid size={{ xs: 4 }}>
                  <Stack>
                    <Typography
                      sx={{
                        fontWeight: 600,
                      }}
                    >
                      Description:
                    </Typography>
                    <Typography
                      noWrap
                      sx={{
                        maxWidth: 200,
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {selectedContactSync.description}
                    </Typography>
                  </Stack>
                </Grid>
              ) : null}
              {selectedContactSync.sourceUser ? (
                <Grid size={{ xs: 4 }}>
                  <Stack>
                    <Typography
                      sx={{
                        fontWeight: 600,
                      }}
                    >
                      Sync User:
                    </Typography>
                    <AvatarChip
                      email={selectedContactSync.sourceUser}
                      type="User"
                      size="small"
                    />
                  </Stack>
                </Grid>
              ) : null}
              {selectedContactSync.groupTitle ? (
                <Grid size={{ xs: 4 }}>
                  <Stack>
                    <Typography
                      sx={{
                        fontWeight: 600,
                      }}
                    >
                      Source Label
                    </Typography>
                    <Typography
                      noWrap
                      sx={{
                        maxWidth: 200,
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {selectedContactSync.groupTitle}
                    </Typography>
                  </Stack>
                </Grid>
              ) : null}
              <Grid size={{ xs: 4 }}>
                <Stack>
                  <Typography
                    sx={{
                      fontWeight: 600,
                    }}
                  >
                    Target Label:
                  </Typography>
                  <Typography
                    noWrap
                    sx={{
                      maxWidth: 200,
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {selectedContactSync.targetGroupName}
                  </Typography>
                </Stack>
              </Grid>
              <Grid size={{ xs: 4 }}>
                <Stack>
                  <Typography
                    sx={{
                      fontWeight: 600,
                    }}
                  >
                    Target Type
                  </Typography>
                  <Typography
                    noWrap
                    sx={{
                      maxWidth: 200,
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {selectedContactSync.targetType}
                  </Typography>
                </Stack>
              </Grid>
              <Grid size={{ xs: 4 }}>
                <Stack>
                  <Typography
                    sx={{
                      fontWeight: 600,
                    }}
                  >
                    Targets:
                  </Typography>
                  {selectedContactSync.allSource ? (
                    <Typography>All</Typography>
                  ) : selectedContactSync.targets ? (
                    <Stack
                      sx={{ width: 270, maxHeight: 100, overflow: 'auto' }}
                      gap={0.5}
                    >
                      {selectedContactSync.targets.map((target) => {
                        return (
                          <AvatarChip
                            key={target}
                            email={target}
                            type={
                              selectedContactSync.targetType as
                                | 'User'
                                | 'Group'
                                | 'OrgUnit'
                                | 'Domain'
                            }
                            size="small"
                          />
                        );
                      })}
                    </Stack>
                  ) : (
                    <Typography
                      noWrap
                      sx={{
                        maxWidth: 270,
                        textOverflow: 'ellipsis',
                      }}
                    >
                      No Targets
                    </Typography>
                  )}
                </Stack>
              </Grid>
              <Grid size={{ xs: 4 }}>
                <Stack>
                  <Typography
                    sx={{
                      fontWeight: 600,
                    }}
                  >
                    Scheduled:
                  </Typography>
                  <Typography
                    noWrap
                    sx={{
                      maxWidth: 200,
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {selectedContactSync.scheduled ? (
                      <Chip
                        variant="outlined"
                        icon={<Check />}
                        label={'Enabled'}
                        color={'success'}
                        size="small"
                      />
                    ) : (
                      <Chip
                        variant="outlined"
                        icon={<DoNotDisturb />}
                        label={'Disabled'}
                        color={'warning'}
                        size="small"
                      />
                    )}
                  </Typography>
                </Stack>
              </Grid>
              {selectedContactSync.scheduled ? (
                <Grid size={{ xs: 4 }}>
                  <Stack flexDirection={'row'} gap={2}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                      }}
                    >
                      Times:
                    </Typography>
                    <Box sx={{ width: 80, maxHeight: 70, overflow: 'auto' }}>
                      {selectedContactSync.times.map((time) => {
                        return (
                          <Typography
                            key={time}
                            noWrap
                            sx={{
                              maxWidth: 80,
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {parseInt(time) === 0
                              ? '12 AM'
                              : parseInt(time) < 12
                              ? `${time} AM`
                              : parseInt(time) === 12
                              ? `${time} PM`
                              : `${parseInt(time) - 12} PM`}
                          </Typography>
                        );
                      })}
                    </Box>
                  </Stack>
                </Grid>
              ) : null}
              {selectedContactSync.scheduled ? (
                <Grid size={{ xs: 4 }}>
                  <Stack flexDirection={'row'} gap={2}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                      }}
                    >
                      Dates:
                    </Typography>
                    <Box sx={{ width: 200, maxHeight: 100, overflow: 'auto' }}>
                      {selectedContactSync.dates.map((date) => {
                        return (
                          <Typography
                            key={date}
                            noWrap
                            sx={{
                              maxWidth: 200,
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {date}
                          </Typography>
                        );
                      })}
                    </Box>
                  </Stack>
                </Grid>
              ) : null}
              {selectedContactSync.scheduled &&
              selectedContactSync.scheduleEndDate ? (
                <Grid size={{ xs: 4 }}>
                  <Stack>
                    <Typography
                      sx={{
                        fontWeight: 600,
                      }}
                    >
                      Expiration Date:
                    </Typography>
                    <Typography
                      noWrap
                      sx={{
                        maxWidth: 200,
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {new Date(
                        selectedContactSync.scheduleEndDate
                      ).toLocaleDateString()}
                    </Typography>
                  </Stack>
                </Grid>
              ) : null}
            </Grid>
          </Stack>
        </>
      }
      primaryButton={{
        loading: false,
        action: handleClose,
        disabled: false,
        title: 'Close',
      }}
    />
  );
}
